import styled from 'styled-components';
export const LoadingContainer = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: translate(-50%, -50%);
`;